export const amendmentsCacheKeys = {
  post_amendment: () => ['post_amendment'] as const,
  put_amendment: () => ['put_amendment'] as const,
  delete_amendment: () => ['delete_amendment'] as const,
  fetch_contracts_invalidate: () => ['membership_contracts'] as const
}
